import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import "@bryntum/schedulerpro/schedulerpro.classic-light.css";
import "@/assets/css/tailwind.css";
import "@/plugins/eventBus";
import "@/plugins/vee-validate";
import "@/plugins/vue-components";
import "@/plugins/vue-confirm";
import "@/plugins/vue-glide";
import "@/plugins/vue-gtm";
import "@/plugins/vue-indicator";
import "@/plugins/vue-moment";
import "@/plugins/vue-plyr";
import "@/plugins/vue-sentry";
import "@/plugins/vue-stripe";
import "@mdi/font/css/materialdesignicons.css";

import amplify from "@/plugins/vue-amplify";
import apolloProvider from "@/plugins/vue-apollo";
import axios from "axios";
import "sweetalert2/dist/sweetalert2.min.css";
import VueAxios from "vue-axios";
import "vue-cal/dist/vuecal.css";
import VueProgressBar from "vue-progressbar";
import "vue-select/dist/vue-select.css";
import VueSweetalert2 from "vue-sweetalert2";

declare var gtag: Function;

Vue.use(VueProgressBar, {
  color: "rgb(30,181,240)",
  failedColor: "red",
  height: "2px",
  position: "relative",
});

router.afterEach((to, from) => {
  if (typeof gtag === 'function') {
    gtag('config', 'G-8XXYS1GC46', {
      page_path: to.fullPath,
    });
  }
});

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
// register component to use

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
  // @ts-ignore
  amplify,
  apolloProvider,
}).$mount("#app");
